import { render, staticRenderFns } from "./sjjy5.vue?vue&type=template&id=bb10ff7a&scoped=true&"
import script from "./sjjy5.vue?vue&type=script&lang=js&"
export * from "./sjjy5.vue?vue&type=script&lang=js&"
import style0 from "./sjjy5.vue?vue&type=style&index=0&id=bb10ff7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb10ff7a",
  null
  
)

export default component.exports